import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, Volume2Icon, VolumeXIcon } from 'lucide-react';
import { useLanguage } from './LanguageContext';
const VIDEO_ID = 'LVc0jS-bkNk';
export function Hero() {
  const {
    t
  } = useLanguage();
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [muted, setMuted] = useState(true);
  const toggleSound = () => {
    const iframe = iframeRef.current;
    if (!iframe?.contentWindow) return;
    const command = muted ? 'unMute' : 'mute';
    iframe.contentWindow.postMessage(JSON.stringify({
      event: 'command',
      func: command,
      args: []
    }), '*');
    setMuted(!muted);
  };
  return <section id="inicio" className="relative min-h-screen flex items-center overflow-hidden bg-ink" data-id="element-128">
      {/* YouTube background video */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-129">
        <iframe ref={iframeRef} title="Jade Latin Music — background" src={`https://www.youtube.com/embed/${VIDEO_ID}?autoplay=1&mute=1&loop=1&playlist=${VIDEO_ID}&controls=0&modestbranding=1&playsinline=1&rel=0&showinfo=0&iv_load_policy=3&disablekb=1&enablejsapi=1`} allow="autoplay; encrypted-media; picture-in-picture" className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none" style={{
        width: '100vw',
        height: '56.25vw',
        minHeight: '100vh',
        minWidth: '177.78vh' // 16:9 of viewport height
      }} data-id="element-130" />
        {/* Overlays for readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-ink/95 via-ink/75 to-ink/40" data-id="element-131" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-ink/60" data-id="element-132" />
      </div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-32 w-full" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-3xl" data-id="element-134">
          <p className="text-gold text-xs md:text-sm tracking-[0.35em] mb-6 font-medium" data-id="element-135">
            {t('hero.eyebrow')}
          </p>
          <h1 className="font-display text-4xl md:text-6xl lg:text-7xl leading-[1.05] text-cream mb-6" data-id="element-136">
            {t('hero.title.1')}{' '}
            <span className="italic gold-text" data-id="element-137">{t('hero.title.2')}</span>
          </h1>
          <p className="text-cream/75 text-lg md:text-xl max-w-2xl mb-10 leading-relaxed" data-id="element-138">
            {t('hero.subtitle')}
          </p>
          <div className="flex flex-wrap gap-4" data-id="element-139">
            <a href="#contacto" className="group inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-gold text-ink font-medium hover:bg-gold-light transition-colors" data-id="element-140">
              {t('hero.cta.primary')}
              <ArrowRightIcon size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-141" />
            </a>
            <a href="#servicios" className="inline-flex items-center px-7 py-3.5 rounded-full border border-gold/40 text-cream hover:border-gold hover:bg-gold/5 transition-colors" data-id="element-142">
              {t('hero.cta.secondary')}
            </a>
          </div>
        </motion.div>
      </div>

      {/* Sound toggle */}
      <button onClick={toggleSound} aria-label={muted ? 'Activar sonido' : 'Silenciar'} className="absolute bottom-8 right-6 md:right-10 z-10 inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-ink/70 backdrop-blur-md border border-gold/40 text-cream hover:text-gold hover:border-gold transition-colors text-xs tracking-wider" data-id="element-143">
        {muted ? <VolumeXIcon size={14} data-id="element-144" /> : <Volume2Icon size={14} data-id="element-145" />}
        {muted ? 'PLAY SOUND' : 'MUTE'}
      </button>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-gold/60 text-xs tracking-[0.3em] z-10 hidden md:block" data-id="element-146">
        {t('hero.scroll')}
      </div>
    </section>;
}